import axios from "axios";

//获取IP系列的产品列表
export function GetBuyType() {
	return axios.get(`/w1/goods/getBuyType`);
}

// 获取到数据列表
export function GetGoodsList(queryData) {
	return axios.get(`/w1/goods/buy/goodslist`, {
		params: queryData
	});
}

// 根据推荐ID所有的商品加入购物车
export function AllToCart(id) {
	return axios.post(`/w1/goods/buy/alladdtocart/${id}`);
}

// 获取到该类型在线数量及价格
export function GetGoodsPriceAndNum(id) {
	return axios.get(`/w1/goods/buy/goodspriceandnum/${id}`);
}